import { ApiInfo } from 'libs/cms/common/types';

export const normalizeApiInfo = (data: any): ApiInfo => ({
  id: data.id,
  title: data.title,
  slug: data.slug,
  summary: data.summary,
  accessLevel: data.accessLevel,
  latestVersion: data.latestVersion,
  apiAuthMethod: data.apiAuthMethod,
  features: data.features,
});
